'use strict';

define('BetslipMainMod',['CrossWindowMessagingFac'],
    function (CrossWindowMessagingFac) {

        angular.module('TVG.BetslipMain', [])
            .factory('CrossWindowMessaging', CrossWindowMessagingFac);
    });

